/* eslint-disable camelcase */
import { makeAutoObservable } from 'mobx';
import {
  makePersistable,
  isHydrated,
  hydrateStore,
  clearPersistedStore,
  getPersistedStore,
} from 'mobx-persist-store';
import type { CookieConsentRequest } from '../models/cookie.js';

class AppState {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'app-state',
      properties: ['lastActive', 'showAutoLogout', 'cookieConsent'],
      storage: window.localStorage,
    });
  }

  public lastActive: number = +new Date();

  public showAutoLogout: boolean = false;

  public cookieConsent: CookieConsentRequest[] = [];

  public setLastActive = () => {
    this.lastActive = +new Date();
  };

  get cookiesAccepted(): CookieConsentRequest[] {
    return this.cookieConsent;
  }

  set cookiesAccepted(values: CookieConsentRequest[]) {
    for (const value of values) {
      const currentCookies = this.cookieConsent.filter(
        ({ cookie_name }) => value.cookie_name !== cookie_name,
      );

      if (!value.expires) {
        const now = new Date();
        const nextYear = new Date(now);
        nextYear.setFullYear(now.getFullYear() + 1);
        value.expires = nextYear.toISOString();
      }

      this.cookieConsent = [...currentCookies, value];
    }
  }

  public async compareLastActive(offset = 0) {
    await this.hydrateStore();
    if (this.lastActive + offset <= +new Date()) {
      return true;
    }

    return false;
  }

  get isHydrated() {
    return isHydrated(this);
  }

  async hydrateStore() {
    await hydrateStore(this);
  }

  async clearStoredDate() {
    await clearPersistedStore(this);
  }

  async getStoredData() {
    return getPersistedStore(this);
  }
}

export const appState = new AppState();
